import { Box } from '@mui/material';
import SectionTitle from 'components/drawers/transaction-drawers/section-title/section-title.component';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  selectIncentivioPaymentFee,
  selectIncentivioPaymentProcessingRate,
} from 'redux/client-config/client-config.selectors';
import { formatCurrency } from 'util/currency';
import DetailsSingleSection from '../detail-single-section/detail-single-section.component';
import DetailsSection from '../details-section.component';

const PaymentDetailsSection = ({ transaction }) => {
  const { t } = useTranslation();
  const { statementDescriptor, chargeAmount, applicationFee, currency } =
    transaction ?? {};
  const processingRate = useSelector(selectIncentivioPaymentProcessingRate);
  const paymentFee = useSelector(selectIncentivioPaymentFee);

  const details = [
    {
      title: t(
        'drawer.transactionDrawer.paymentDetailsSection.statementDescriptor',
      ),
      detail: statementDescriptor,
    },
    {
      title: t('drawer.transactionDrawer.paymentDetailsSection.amount'),
      detail: formatCurrency(chargeAmount, currency),
    },
    {
      title: t('drawer.transactionDrawer.paymentDetailsSection.fee'),
      detail: formatCurrency(applicationFee, currency),
      popoverContent: `${processingRate}% + $${paymentFee}`,
    },
    {
      title: t('drawer.transactionDrawer.paymentDetailsSection.net'),
      detail: formatCurrency(chargeAmount - applicationFee, currency),
    },
  ];

  return (
    <Box>
      <SectionTitle
        title={t('drawer.transactionDrawer.paymentDetailsSection.title')}
      />
      <DetailsSection>
        {details.map(data => (
          <DetailsSingleSection {...data} key={data.title} />
        ))}
      </DetailsSection>
    </Box>
  );
};

export default PaymentDetailsSection;
